import initialState from "AppCore/Store/initialState";
import Constants from "AppCore/Constants";

const { REDUCER: C } = Constants;


export default (state = initialState.pricelists, action) => {
	switch (action.type) {
	case C.SET_PRICELISTS:
		return {
			...state,
			...action.pricelists,
			loaded: true
		};
	case C.CLEAR_PRICELISTS:
		return initialState.pricelists;
	default:
		return state;
	}
}